<template>
  <div class="add-integrated-person">
    <el-dialog title="新增" v-dialogDrag :visible.sync="showPanel" width="1200px" :modal="false" class="dialog"
      @close="close">
      <div class="content" style="height: 480px">
        <el-form :inline="true">
          <el-form-item label="姓名">
            <el-input placeholder="请输入" v-model="name"></el-input>
          </el-form-item>
          <el-form-item label="员工类型">
            <el-select v-model="personOrAccountType">
              <el-option v-for="item in personType" :key="item.id" :value="item.id" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="部门">
            <el-input clearable placeholder="请选择部门" @click.native="showTree = !showTree" v-model="departmentNames"
              @clear="handleClear"></el-input>
            <div class="tree-container" v-show="showTree" @mouseleave="showTree = false">
              <el-tree :data="departmentData" ref="tree" node-key="departmentCode" :props="treeProps"
                :renderContent="renderContent" :filter-node-method="filterNode" show-checkbox
                @check-change="handleCheckChange" @check="handleCheck">
              </el-tree>
            </div>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="getPersonList">查询</el-button>
            <el-button type="info" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData" height="400px" @selection-change="handleSelectionChange">
          <el-table-column type="selection" />
          <el-table-column prop="name" label="姓名" />
          <el-table-column prop="workNo" label="工号" />
          <el-table-column prop="departmentName" label="部门" />
          <el-table-column prop="position" label="岗位" />
          <el-table-column prop="phone" label="手机" />
        </el-table>
        <el-row class="tc">
          <el-pagination class="page-comp" background layout="total, sizes, prev, pager, next, jumper"
            :page-size="page.pageSize" :total="page.total" :current-page="page.currentPage" @size-change="sizeChange"
            @current-change="pageChange" @prev-click="pageChange" @next-click="pageChange" />
        </el-row>
      </div>
      <div slot="footer">
        <el-button type="info" @click="close">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api";
import { Cache } from "$utils";
export default {
  components: {},
  props: {
    workGroupCode: {
      type: String,
      default: "",
    },
    personType: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showPanel: false,
      unselectedList: [],
      selectedList: [],
      name: "",
      personOrAccountType: '',
      treeData: [],
      tableData: [],
      treeProps: {
        label: "departmentName",
        id: "departmentCode",
        children: "subDepartmentList",
      },
      page: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      departmentData: [],
      showTree: false,
      departmentNames: "",
      departmentCodeList: [],

    };
  },

  watch: {
    name(val) {
      this.$refs.tree.filter(val);
    },
    personOrAccountType(val) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.getOutList();
      }, 17);
    },
    showPanel(val) {
      if (!val) {
        this.clearData()
      }
    }
  },

  methods: {
    handleSelectionChange(value) {
      this.selectedList = value;
    },
    handleClear() {
      this.$refs.tree.setCheckedNodes([]);
      this.departmentCodeList = [];
    },
    handleCheck(data, nodes) {
      this.departmentNames = nodes.checkedNodes
        .map((item) => item.departmentName)
        .join(",");
      this.departmentCodeList = nodes.checkedKeys;
    },
    handleCheckChange(data, node) {
      // console.log(data, node)
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getPersonList();
    },

    pageChange(pageNo) {
      this.page.currentPage = pageNo;
      this.getPersonList();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    toggleCheck(item) {
      item.checked = !item.checked;
    },
    open({ integratedGroupCode } = {}) {
      this.showPanel = true;
      this.integratedGroupCode = integratedGroupCode;
      this.getPersonList();
      this.getDepartmentTree();
    },
    // 获取部门树
    async getDepartmentTree() {
      const { success, returnObj } = await this.$fetch(api.queryDepartmentTree);
      this.departmentData = returnObj;
    },
    // 获取人员
    async getPersonList() {
      let params = {
        departmentCodeList: this.departmentCodeList,
        name: this.name, // 员工或者保卫姓名
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        personOrAccountType: this.personOrAccountType,
      };
      const {
        success,
        returnObj: { list, total },
        msgContent,
      } = await this.$fetch(api.queryPersonnelOrAccount, params);
      if (success) {
        if (list && list.length) {
          this.tableData = list;
          this.page.total = total
        } else {
          this.tableData = []
        }
      } else {
        msgContent && this.$message.error(msgContent);
      }
    },
    reset() {
      this.clearData()
      this.getPersonList()
    },
    clearData() {
      this.departmentCodeList = []
      this.name = ''
      this.page.pageSize = 10
      this.page.currentPage = 1
      this.page.total = 0
      this.departmentNames = ''
      this.personOrAccountType = ''
    },
    // 自定义渲染节点
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node personwidth" title={node.label}>
          <span>{node.label}</span>
        </span>
      );
    },
    // 移动人员
    transferPerson(type) {
      if (type === "left") {
        let selectedPerson = this.$refs.tree.getCheckedNodes();
        if (selectedPerson.length) {
          this.selectedList = this.selectedList.concat(selectedPerson);
          let data = this.selectedList.map((item) => {
            return {
              ...item,
              name: item.name,
              checked: true,
            };
          });
          this.selectedList = data;

          selectedPerson = selectedPerson.map((item) => {
            return {
              ...item,
              name: item.name,
              checked: true,
            };
          });

          this.treeData.forEach((item, index) => {
            selectedPerson.forEach((items) => {
              if (items.personOrAccountCode === item.personOrAccountCode) {
                item.checked = items.checked;
              }
            });
          });

          this.treeData = this.treeData.filter((item) => !item.checked);
        } else {
          selectedPerson = [];
        }
      } else if (type === "right") {
        // 移除右边已选人员
        if (this.selectedList.length) {
          let rightChoose = this.selectedList.filter(
            (item) => item.checked === true
          );
          this.selectedList = this.selectedList.filter(
            (item) => item.checked === false
          );
          this.treeData = this.treeData.concat(rightChoose);
        } else {
          this.selectedList = [];
        }
      }
    },
    // 根据key对数组对象去重
    reduceArr(arr, key) {
      let obj = {};
      let newArr = arr.reduce((cur, next) => {
        obj[next[key]] ? "" : (obj[next[key]] = true && cur.push(next));
        return cur;
      }, []);
      return newArr;
    },
    //点击确定按钮,对外暴露已选人员
    submit() {
      if (this.selectedList.length) {
        let personInfo = [];
        this.selectedList
          .forEach((item) => {
            personInfo.push({
              personOrAccountCode: item.personOrAccountCode,
              personOrAccountType: item.personOrAccountType,
            });
          });
        let params = {
          personOrAccountInfoList: personInfo,
          integratedGroupCode: this.integratedGroupCode,
        };
        this.$fetch(api.addIntegratedGroupInfo, params).then((res) => {
          if (res.success) {
            this.close();
            this.$message.success('添加人员成功');
            this.$emit("refreshData");
          } else {
            this.$message.error(res.msgContent);
          }
        });
      } else {
        this.$message.warning("请选择人员");
      }
    },
    close() {
      this.showPanel = false;
      this.selectedList.length = 0;
      this.account = "";
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.add-integrated-person {
  .content {
    &-top {
      display: flex;
      justify-content: space-around;
      align-content: space-around;
      text-align: center;
      padding-bottom: 30px;

      &-left,
      &-right {
        width: 48%;
        height: 350px;
        border-width: 1px;
        border-style: solid;

        h2 {
          background-color: rgba(38, 43, 55, 1);
          margin-bottom: 0;
        }

        .account {
          line-height: 24px;
          padding: 0 10px;
          text-align: left;
        }

        .group-list {
          height: calc(100% - 90px);
          overflow-y: scroll;
        }

        .person-list {
          text-align: left;
          padding: 5px 10px;
          height: calc(100% - 36px);
          overflow-y: scroll;

          .person {
            padding: 5px 0px;
            color: #b9c3d9;
            font-size: 14px;
            display: flex;

            .name-icon {
              margin: 0 5px;
            }

            .checked-name {
              display: inline-block;
              max-width: 140px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-left: 5px;
            }
          }
        }
      }

      &-middle {
        .to-left {
          margin: 100px 0px 10px 0px;
          background: transparent;
        }

        .to-right {
          margin-left: 2px;
          background: transparent;
        }
      }
    }
  }

  .dialog {
    .el-dialog__body {
      padding: 30px;
    }
  }

  .footer {
    text-align: right;
    padding: 20px 20px 20px 0;
  }

  .title {
    height: 36px;
    line-height: 36px;
    font-weight: normal;
  }

  .tree-list .personwidth {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #b9c3d9;
  }

  .tree-list .el-tree .is-current>.el-tree-node__content,
  .tree-list .el-tree-node__content:hover {
    background-color: transparent;
  }

  .person-list .el-checkbox__input.is-checked+.el-checkbox__label {
    // color: #c9d5ec;
  }

  .expand {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 2px;
    border: 1px solid #b3cbf1;
  }

  .tree-container {
    position: absolute;
    top: 40px;
    width: 200px;
    height: 300px;

    overflow-y: scroll;
    z-index: 10;
    @include set_theme_color(background-color, page-tab-item-bg-color);
  }

  .page-comp {
    /* margin: 10px 0; */
    width: 100%;
    margin-top: 5px;
  }
}
</style>
